import React, {useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {Spinner} from "react-bootstrap";
import '../../assets/posTest.scss'
import SettingController from "../../controller/SettingController";
import {useTranslation} from "react-i18next";

export default function PosTest() {
    const {t} = useTranslation();
    const [loading, setLoading] = useState(false);
    const {shopId} = useParams();

    const navigator = useNavigate();

    return (
        <section className={'local-test-printer pos-test'}>
            <div>
                <p>{t("setting.posTest")}</p>
                <button type="submit"
                        onClick={() => SettingController.posTest(setLoading, navigator, shopId as string)}>
                    {loading ? <Spinner/> : t("test")}
                </button>
            </div>
        </section>
    );
}